module.exports = __webpack_public_path__ + "assets/img/btn-back-4d63fbcb.png";